module.exports = __webpack_public_path__ + "static/media/55-iveco-mercedes.24dac84c.jpg";